import { render, staticRenderFns } from "./ModuleInfoSidebar.vue?vue&type=template&id=2bd9f5f4"
import script from "./ModuleInfoSidebar.vue?vue&type=script&lang=js"
export * from "./ModuleInfoSidebar.vue?vue&type=script&lang=js"
import style0 from "./ModuleInfoSidebar.vue?vue&type=style&index=0&id=2bd9f5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports